module.exports = __webpack_public_path__ + "static/media/spicy-dill-mama-mb-fr.4edea41c.jpg";